import { useContext } from "react";
import { FormattedMessage } from "react-intl";
import { DeviceReducerActionType } from "../reducers/deviceReducer";
import { UIReducerActionType } from "../reducers/uiReducer";
import { UIContext } from "../contexts/UIContext";
import { DeviceContent, DeviceContext } from "../contexts/DeviceContext";
import "../styles/DeviceCard.css";

interface DeviceCardProps {
  device: DeviceContent;
}

const DeviceCard = ({ device }: DeviceCardProps) => {
  const { deviceDispatch } =  useContext(DeviceContext);
  const { uiState, uiDispatch } = useContext(UIContext);
  
  const onDeviceCardClick = () => {
    const { showDeviceDetail } = uiState;
    deviceDispatch({ type: DeviceReducerActionType.UPDATE_ACTIVE_DEVICE, payload: device.guid });
    if(showDeviceDetail) {
      uiDispatch({ type: UIReducerActionType.SHOW_DETAIL, payload: false });
    }
  };

  const onDeviceDetailClick = () => {
    uiDispatch({ type: UIReducerActionType.SHOW_DETAIL, payload: true });
  };
  
  return (
    <li key={ device.guid } className={ device.isActive ? "devicecard devicecard-active" : "devicecard" } onClick={ onDeviceCardClick }>
      <div className="devicecard-img">
        { device.os === 'Android' ? <div className="devicecard-icon devicecard-icon-android"></div> : <div className="devicecard-icon devicecard-icon-ios"></div> } 
      </div>
      <div className="devicecard-info">
        <div className="device-name">{ device.displayName }</div>
        <div className="devicecard-detail-text" onClick={ onDeviceDetailClick }>
          <FormattedMessage id="device_detail" />
        </div>
      </div>
    </li>
  );
};

export default DeviceCard;
